"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataLoader_1 = require("./DataLoader");
const axios_1 = require("axios");
class AxiosDataLoader {
    constructor(url, axios = axios_1.default.create()) {
        this.url = url;
        this.axios = axios;
        this.cachedFileSize = undefined;
    }
    load(start, size) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.get(this.url, {
                responseType: 'arraybuffer',
                headers: { "Range": `bytes=${start}-${size ? start + size - 1 : ""}` }
            });
            if (416 == response.status) {
                throw new DataLoader_1.OutOfRangeError(this.url, start, size);
            }
            if (response.data instanceof Buffer) {
                return new Uint8Array(response.data).buffer;
            }
            else {
                return response.data;
            }
        });
    }
    loadStream(start, size) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.axios.get(this.url, {
                responseType: 'stream',
                headers: { "Range": `bytes=${start}-${size ? start + size - 1 : ""}` }
            });
            if (416 == response.status) {
                throw new DataLoader_1.OutOfRangeError(this.url, start, size);
            }
            return response.data;
        });
    }
}
exports.AxiosDataLoader = AxiosDataLoader;
//# sourceMappingURL=AxiosDataLoader.js.map